'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "create-dashboard-dialog" */'./CreateDashboardDialogContainer');
export default Loadable({
  loader,
  LoadingComponent: () => null
});